export default "__VITE_ASSET__VFk4WPeV__"